<div style="margin-left: 4%; margin-right: 4%">
  <div style="margin-top: 1.875rem">
    <span class="chargingProjectHeader">Charging Project Setup - Activity Selection</span>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <input [(ngModel)]="fundingProjectID" placeholder="Funding Project ID" matInput />
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [compareWith]="compareState" [(value)]="state" placeholder="State">
        @for (option of stateOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option.state }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [(value)]="businessUnit" placeholder="Business Unit">
        @for (option of businessUnitOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div style="width: 100%; text-align: center; margin-top: 1.563rem">
  <div
    style="
      width: 93%;
      background-color: #f3fafd;
      display: block;
      margin: auto;
      padding-bottom: 2rem;
    "
  >
    <div style="padding-top: 1.625rem; text-align: left; padding-left: 3.5%">
      <span style="font-size: 1.125rem; color: #696969">Select Activities:</span>
    </div>
    @if (checkboxValues) {
      <div style="width: 96%; background-color: white; margin: auto; margin-top: 0.5rem">
        <div style="padding-top: 1.563rem">
          @for (group of activityGroups; track group; let i = $index) {
            <div>
              @if (group.groupName) {
                <div style="border-bottom: 0.063rem solid #707070; margin-top: 1rem"></div>
              }
              @if (group.groupName) {
                <div
                  style="
                    width: 16.375rem;
                    margin-top: -1rem;
                    padding-left: 1.5rem;
                    background: #ffffff;
                    text-align: left;
                  "
                >
                  <span style="font-size: 1.125rem; color: #696969; font-weight: 600">{{
                    group.groupName
                  }}</span>
                </div>
              }
              <div style="display: flex; margin-top: 0.625rem">
                <div
                  [class.hiddenText]="!group.groupName"
                  style="display: inline-block; padding-left: 1.5rem; float: left; width: 22.75rem"
                >
                  <mat-checkbox
                    color="primary"
                    style="float: left"
                    [checked]="allChecked(i)"
                    (change)="checkAll(i)"
                  >
                    <span style="color: #696969">Select all {{ group.groupName }}</span>
                  </mat-checkbox>
                </div>
                <div style="display: inline-block; width: 19.75rem">
                  @for (activity of activityLeftDisplay[i]; track activity; let j = $index) {
                    <div style="text-align: left; margin-bottom: 0.938rem">
                      <mat-checkbox
                        color="primary"
                        [checked]="checkboxValues[i][j]"
                        (change)="toggleChecked(i, j)"
                      >
                        <span style="color: #696969; white-space: normal"
                          >{{ activity.activityID }} - {{ activity.description }}</span
                        >
                      </mat-checkbox>
                    </div>
                  }
                </div>
                <div style="display: inline-block; width: 19.75rem; margin-left: 10rem">
                  @for (activity of activityRightDisplay[i]; track activity; let j = $index) {
                    <div style="text-align: left; margin-bottom: 0.938rem">
                      <mat-checkbox
                        color="primary"
                        [checked]="checkboxValues[i][leftDisplayLength[i] + j]"
                        (change)="toggleChecked(i, leftDisplayLength[i] + j)"
                      >
                        <span style="color: #696969; white-space: normal"
                          >{{ activity.activityID }} - {{ activity.description }}</span
                        >
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
<div style="margin-bottom: 4.375rem; margin-top: 3.75rem">
  <div class="startOverButton" (click)="goToPreviousPage()">
    <span style="font-size: 0.875rem; color: #00789e">PREVIOUS PAGE</span>
  </div>
  <div style="display: inline-block">
    <div class="exitButton" (click)="exitPage()">
      <span class="exitText">EXIT</span>
    </div>
  </div>
  <div style="display: inline-block; float: right">
    <div style="display: inline-block">
      <button
        class="confirmButton"
        (click)="goToSummaryPage()"
        [disabled]="continueDisabled()"
        [class.buttonDisabled]="continueDisabled()"
      >
        <span class="confirmText">CONTINUE</span>
      </button>
    </div>
  </div>
</div>
